import React from "react"
import EditCollectionForm from "./EditCollectionForm"
import{ styled } from "@mui/material/styles"
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material"

import { inject, observer } from "mobx-react"

const CreateCollectionAccordionContainer = styled('div')``

const AccordionLabel = styled('label')`
  font-weight: 300;
  font-size: 24px;
  display: flex;
  align-items: center;
`

const SFAccordionSummary = styled(AccordionSummary)`
  background-color: whitesmoke;
  padding: 0 20px;
`

const CollectionThumbImage = styled('img')`
  height: 50px;
  margin-right: 20px;
`

@inject("sampleStore")
@inject("collectionStore")
@observer
export default class CollapsedCollection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      submitSuccess: false,
      isExpanded: false,
    }
  }

  handleAccordionChange = (e, isExpanded) => {
    if (isExpanded) {
      this.setState({ isExpanded: true })
    } else {
      this.setState({ isExpanded: false })
    }
  }

  render() {
    const { isExpanded } = this.state
    const { collectionStore } = this.props
    const collection = collectionStore.focusedCollection
    return (
      <CreateCollectionAccordionContainer>
        <Accordion expanded={isExpanded} onChange={this.handleAccordionChange}>
          <SFAccordionSummary
            expandIcon={<i className="fas fa-angle-down" aria-hidden="true"></i>}
          >
            <AccordionLabel>
              <CollectionThumbImage src={collection.imageThumbUrl} />
              {collection.name} collection
            </AccordionLabel>
          </SFAccordionSummary>
          <AccordionDetails>
            <EditCollectionForm
              collection={collection}
              handleAccordionChange={this.handleAccordionChange}
            />
          </AccordionDetails>
        </Accordion>
      </CreateCollectionAccordionContainer>
    )
  }
}
